import {SpinnerWithBackdrop} from '@eitje/web_components'
import {useSelector} from 'react-redux'

export const PageSpinner = ({children}) => {
	const isSpinning = useSelector(state => !!state.api.loading)

	return (
		<>
			{children}
			<SpinnerWithBackdrop backdropColor="blue" isSpinning={isSpinning} size="large" />
		</>
	)
}
